import * as React from 'react';
import { useEffect } from 'react';

import { cn } from './cn';
import { Surface } from './Surface';

// Background — full-viewport page chrome. Paints the muted backdrop
// behind every React route. The jQuery side effect bridges to the
// Backbone shell's `.panels_container` to keep the scrollbar gutter
// stable while a React page is mounted; the cleanup restores the
// original style on unmount. Stays until the Backbone shell is gone.
//
// `heightOffset` reserves vertical space for the Backbone-era top
// header above this React route (50px default; pages that sit under a
// taller header — Plans, Integrations Licenses — pass 90).

const Background = ({ children, className: _className, style: _style, heightOffset = 50 }) => {
    useEffect(() => {
        const panelsContainer = $('.panels_container');

        if (!panelsContainer) {
            return;
        }

        panelsContainer.css('scrollbar-gutter', 'stable');

        return () => {
            panelsContainer.css('scrollbar-gutter', '');
        };
    }, []);

    return (
        <div
            className="tw-flex tw-justify-center tw-items-start tw-flex-col tw-py-10 tw-bg-muted"
            style={{ minHeight: `calc(100vh - ${heightOffset}px)` }}
        >
            {children}
        </div>
    );
};

// Container — the white content card centred inside Background. Paints
// itself by composing <Surface border={false} fullHeight /> so the page
// card carries the same radius and padding as ContentCard / StatCard /
// PasswordRequirements et al. Page-card chrome is layout only:
// max-width + mx-auto + flex-1.
//
// `variant` controls how children stack inside:
//   column (default) → flex-col, vertical stacking (most pages)
//   row              → flex-row, sidebar + main layouts (UserProfile,
//                       Plans, Chat, CustomDashboard)

const VARIANT_INNER_CLASSNAMES = {
    column: 'tw-flex tw-h-full tw-flex-col',
    row: 'tw-flex tw-h-full'
};

const Container = ({ children, className: _className, style: _style, variant = 'column' }) => (
    <div className="tw-w-[90%] tw-max-w-screen-2xl tw-mx-auto tw-flex-1 tw-mb-5">
        <Surface border={false} fullHeight rounded="large">
            <div className={cn(VARIANT_INNER_CLASSNAMES[variant], 'tw-w-full')}>
                {children}
            </div>
        </Surface>
    </div>
);

export { Background, Container };
